<template>
  <div>
    <div v-if="![1].includes(externalSoftware)" style="font-size: 22px; font-weight: bold; padding: 60px">
      {{ $t("export.shiftBookings.onlyAvailableForDPW") }}
    </div>
    <div v-else class="main-view-padding has-header">
      <div class="header main">
        <div class="align-left">
          <md-date-select :init-start="timeframeStart" :init-end="timeframeEnd" @change="dateRangeChanged" display-mode="header"/>
        </div>
        <div class="align-middle">
          <headerbuttonstack :state="headerButtons" />
        </div>
        <div class="align-right">
          <headerbuttonstack :state="sideButtons" />
        </div>
      </div>
      <div class="sub-header">
        {{$t("export.shiftBookings.title")}}
      </div>

      <div v-if="loading">
        <i class="fas fa-circle-notch fa-spin"></i>
        {{$t("export.shiftBookings.pleaseWait")}}<br/>
        {{$t("export.shiftBookings.loading")}}<br/>
        <div
          style="width: 100%; clear: both; border-bottom: 1px solid #ccc; margin-top: 25px"
        ></div>
      </div>

      <div class="parentBox" v-if="!loading">

        <div class="settings xColumn">
            <div class="header">
              <div style="float: left;">{{$t("export.shiftBookings.selectStores")}}</div>
              <div v-if="countNotConfirmedSelectedStores > 0" style="float: left; padding: 3px 0px 0px 10px; font-size: 12px; color: var(--contrast-4);">
               {{ countNotConfirmedSelectedStores === 1 ? $t("export.shiftBookings.notConfirmedSingle") : $t("export.shiftBookings.notConfirmedMultiple", { count: countNotConfirmedSelectedStores }) }}
              </div>
              <div style="text-align: right; float: right !important;">
                <buttonc
                  :label="$t('export.shiftBookings.deselectAll')"
                  class=""
                  type="no-border"
                  :disabled="buildingPreviewTable"
                  @click="selectAllStores(false)"
                />
                <buttonc
                  :label="$t('export.shiftBookings.selectAll')"
                  class=""
                  type="no-border"
                  :disabled="buildingPreviewTable"
                  @click="selectAllStores()"
                />
              </div>
            </div>
            <div style="float: left !important; margin: 4px 0px 4px -5px;">
                <buttonc v-for="store in storeArray" v-bind:key="store.id"
                  style="margin-bottom: 6px"
                  :disabled="buildingPreviewTable"
                  :label="store.name"
                  v-bind:tooltip="monthlyStatements[store.id] && monthlyStatements[store.id].confirmed ? '' : 'Monat nicht abgeschlossen'"
                  :icon="monthlyStatements[store.id] && monthlyStatements[store.id].confirmed ? 'fa-check' : 'fa-times-circle'"
                  :active="selectedStores != null && selectedStores.includes(store.id)"
                  @click="selectedStores.includes(store.id) ? selectedStores = selectedStores.filter(id => id !== store.id) : selectedStores.push(store.id); selectionChanged=true;"/>
            </div>
        </div>


        <div class="preview">
          <div class="sub-header" style="display: flex; justify-content: space-between;">
            <div>{{$t("export.shiftBookings.exportPreview")}}</div>
            <div style="text-align: right;" class="">
              <buttonc
                :label="$t('export.shiftBookings.regeneratePreview')"
                class=""
                type="no-border"
                :disabled="buildingPreviewTable || !previewLoadable"
                @click="loadPreview()"
              />
            </div>
          </div>
          <div>
            <table class="table">
              <thead>
                <tr>
                  <th>{{$t('export.shiftBookings.companyNumber')}}</th>
                  <th>{{$t('export.shiftBookings.personnelId')}}</th>
                  <th>{{$t('export.shiftBookings.date')}}</th>
                  <th>{{$t('export.shiftBookings.from')}}</th>
                  <th>{{$t('export.shiftBookings.to')}}</th>
                  <th>{{$t('export.shiftBookings.absenceType')}}</th>
                  <th>{{$t('export.shiftBookings.dayFlag')}}</th>
                  <th>-</th>
                  <th>{{$t('export.shiftBookings.holidayAdjustment')}}</th>
                  <th>{{$t('export.shiftBookings.holidayAdjustmentHours')}}</th>
                </tr>
              </thead>
              <tbody v-if="buildingPreviewTable">
                <tr>
                  <td colspan="10">
                    <i class="fas fa-circle-notch fa-spin"></i>
                    <br /><strong>{{$t('export.shiftBookings.generatingPreview')}}</strong>
                  </td>
                </tr>
              </tbody>
              <tbody v-else-if="previewExists">
                <tr v-for="entry in preview" v-bind:key="entry.employeeId">
                  <td>{{ entry.companyNumber }}</td>
                  <td>{{ entry.personnelId }}</td>
                  <td>{{ entry.date }}</td>
                  <td>{{ entry.from }}</td>
                  <td>{{ entry.to }}</td>
                  <td>{{ entry.absenceType }}</td>
                  <td>{{ entry.dayFlag }}</td>
                  <td></td>
                  <td>{{ entry.holidayAdjustment }}</td>
                  <td>{{ entry.holidayAdjustmentHours }}</td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="10">
                    <buttonc
                      :label="$t('export.shiftBookings.generatePreview')"
                      class=""
                      type="no-border"
                      :disabled="buildingPreviewTable || !previewLoadable"
                      @click="loadPreview()"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import VueEventBus from "@/vue-event-bus";
import MdDateSelect from '@/components/uicomponents/md-date-select';
export default {
  components: {
    MdDateSelect
  },
  name: "ExportDpwShiftData",
  data() {
    return {
      loading: false,
      loadingExport: false,
      loadingDownload: false,
      buildingPreviewTable: false,
      selectionChanged: false,

      companyNumber: "",
      selectedStores: null,
      csv: "",
      preview: [],
      monthlyStatements: {},

      timeframeStart: this.$helpers.getMomentTZ().clone().startOf("month"),
      timeframeEnd: this.$helpers.getMomentTZ().clone().endOf("month"),
    };
  },
  computed: {
    ...mapGetters([
      "companyId",
      "externalSoftware",
      "storeArray"
    ]),
    headerButtons() {
      let view = this;

      let state = {
        buttons: [
          {
            type: "block border-r",
            icon: "fa-refresh",
            show: true,
            disabled: view.loading || view.buildingPreviewTable,
            click: () => {
              view.refresh();
            },
            tooltip: this.$t('export.shiftBookings.reloadData'),
          },
          // {
          //   type: "block",
          //   icon: "fa-server",
          //   show: view.previewExists && [54, 30].includes(parseInt(view.$store.state.companyId)),
          //   disabled: view.loading,
          //   click: () => {
          //     view.saveOnSFTP();
          //   },
          //   tooltip: this.$t('export.shiftBookings.saveOnSFTP'),
          //   title: this.$t('export.shiftBookings.saveOnSFTP'),
          // },
          {
            type: "block border-r",
            icon: "fa-file-download",
            show: view.previewExists,
            disabled: view.loading,
            click: () => {
              view.downloadCSV();
            },
            tooltip: this.$t('export.shiftBookings.downloadCSV'),
            title: this.$t('export.shiftBookings.downloadCSV'),
          },
          {
            type: "block border-r",
            icon: "fa-table-cells",
            show: !view.previewExists && !view.buildingPreviewTable,
            disabled: view.loading || !view.previewLoadable,
            click: () => {
              view.loadPreview();
            },
            tooltip: this.$t('export.shiftBookings.generatePreview'),
            title: this.$t('export.shiftBookings.generatePreview'),
          },
          {
            show: false,
            type: "block",
            icon: "fa-spinner fa-spin",
            click: () => {
            },
            tooltip: this.$t('export.shiftBookings.generatingPreview'),
          },
          {
            type: "block border-r",
            icon: "fa-file-export",
            show: false,
            disabled: view.loading || view.loadingDownload,
            click: () => {
              view.exportCSV();
            },
            tooltip: this.$t('export.shiftBookings.exportToPayroll'),
            title: this.$t('export.shiftBookings.exportToPayroll'),
          },
          {
            show: view.buildingPreviewTable,
            type: "block border-r",
            icon: "fa-spinner fa-spin",
            click: () => {
            },
            tooltip: this.$t('export.shiftBookings.generatingPreview'),
          }
      ],
        helperLinks: [
          {
            title: this.$t('export.shiftBookings.getSupport'),
            helperText: this.$t('export.shiftBookings.helperText'),
            externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/group/11",
            externalLabel: this.$t('export.shiftBookings.contactSupport'),
            cancelLabel: this.$t('export.shiftBookings.close'),
          }
        ]
      };

      state.buttons.push();

      return state;
    },
    sideButtons() {
      let view = this;

      let state = {
        buttons: [],
      };

      return state;
    },
    countNotConfirmedSelectedStores() {
      let view = this;
      return view.selectedStores ? view.selectedStores.filter(storeId => !view.monthlyStatements[storeId] || !view.monthlyStatements[storeId].confirmed).length : 0;
    },
    previewExists() {
      let view = this;
      return view.preview && Object.values(view.preview).length > 0;
    },
    previewLoadable() {
      let view = this;
      return view.selectedStores && view.selectedStores.length > 0;
    }
  },
  watch: {
    companyId: function (newVal, oldVal) {
      this.refresh();
    },
    selectionChanged: function (newVal, oldVal) {
      if (newVal) {
        this.preview = [];
        this.csv = "";
        this.selectionChanged = false;
      }
    }
  },
  created: function () {
    //console.log("CREATED");
  },
  beforeDestroy: function () {
  },
  mounted() {
    this.refresh();
  },
  methods: {
    refresh: function () {
      let view = this;
      view.loading = true;

      view.selectedStores = view.selectedStores == null ? view.storeArray.map(store => store.id) : view.selectedStores;
      view.preview = [];
      view.csv = "";
      view.companyNumber = "";
      view.selectionChanged = false;

      let promises = [];
      // promises.push(view.loadPreview());
      promises.push(view.loadAllMonthlyStatements());
      promises.push(
        view.$helpers
            .GetCompanySettings()
            .then((response) => {
              if (response.data && response.data[0] && response.data[0].companyNumber != null) {
                view.companyNumber = response.data[0].companyNumber;
              }
            })
            .catch((error) => {
              console.log(error);
            })
      );

      Promise.all(promises).finally(() => {
        view.loading = false;
      });
    },

    selectAllStores(select = true) {
      if (select) {
        this.selectedStores = this.storeArray.map(store => store.id);
      } else {
        this.selectedStores = [];
      }
      this.selectionChanged = true;
    },

    dateRangeChanged({ from, to, mode }) {
      console.log(from, to, mode);
      this.timeframeStart = this.$helpers.getMomentFromStringTZ(from);
      this.refresh();
    },

    // preview
    loadPreview() {
      let view = this;
      view.buildingPreviewTable = true;

      let url = '/api/sec/dpw/shifts/exports/create';
      let baseurl = url;
      url = view.$helpers.appendParam("companyId", view.$store.state.companyId, url, baseurl);
      url = view.$helpers.appendParam("selectedStores", view.selectedStores, url, baseurl);
      url = view.$helpers.appendParam("from", view.timeframeStart.toISOString(), url, baseurl);

      return view.axios({
        method: "get",
        headers: {
          'AUTHORIZATION': "Bearer " + view.$store.state.jwt
        },
        url: url
      }).then((response) => {
        view.preview = response.data.exportObject;
        view.csv = response.data.csv;
        if (!view.previewExists) {
          view.$helpers.info(
            "Info",
            "Es wurden keine Zeitbuchungen für den ausgewählten Zeitraum gefunden."
          );
        }
      }).catch((e) => {
        view.preview = [];
        view.$helpers.error(
          "Fehler",
          "Fehler beim Erzeugen der Vorschau."
        );
      }).finally(() => {
        view.buildingPreviewTable = false;
      });
    },

    // export
    exportCSV() {
      let view = this;
      view.loadingExport = true;

      let url = '/api/sec/dpw/shifts/exports/export';
      let baseurl = url;
      url = this.$helpers.appendParam("companyId", this.$store.state.companyId, url, baseurl);

      this.axios({
        method: "get",
        headers: {
          'AUTHORIZATION': "Bearer " + this.$store.state.jwt
        },
        url: url
      }).then((response) => {
        view.loadingExport = false;
        view.$helpers.info(
          "Info",
          "Export in das LV Tool wurde erfolgreich angestoßen."
        );
      }).catch((e) => {
        view.loadingExport = false;
        view.$helpers.error(
          "Fehler",
          "Fehler beim Erzeugen des Exports."
        );
      });
    },

    // download
    downloadCSV() {
      let view = this;
      let filename = "";
      if (view.companyNumber != "") {
        filename += view.companyNumber + " - ";
      }
      filename += "CSV Export - Zeitbuchungen";
      filename += " - " + view.timeframeStart.format('MMMM YYYY');

      view.$helpers.forceFileDownload(atob(view.csv), filename + ".csv");
    },
    saveOnSFTP: function(){
      let view = this;
      let canExport = true;
      Object.values(view.preview).forEach(previewEntry => {
        if(previewEntry.personnelId == null || previewEntry.personnelId === ""){
          canExport = false;
        }
      });
      if(canExport){
        let view = this;
        let url = '/api/sec/dpw/shifts/exports/saveOnSFTP';

        let payload = {
          companyId: this.$store.state.companyId,
          from: view.timeframeStart.format('YYYY-MM-DD'),
          csv: view.csv
        }

        this.axios({
          method: 'post',
          headers: {
            'AUTHORIZATION': "Bearer "+this.$store.state.jwt
          },
          url: url,
          data: payload
        }).then(response => {
          view.$helpers.success('Export erfolgreich', 'Die Datei wurde erstellt und gespeichert');
        }).catch(function (error) {
          console.log(error);
          view.$helpers.error('Export fehlgeschlagen', 'Export konnte nicht abgelegt werden!');
        })
      }else{
        view.$helpers.error('Export fehlgeschlagen', 'Personalnummer fehlt bei mindestens einem Mitarbeiter!');
      }
    },

    loadAllMonthlyStatements() {
      let view = this;

      console.log("loading MFS...");

      // console.log("stores", view.stores);
      // console.log("storesMap", view.storesMap);

      let promises = [];

      for (let j = 0; j < view.storeArray.length; j++) {
        console.log(view.storeArray[j].id);
        promises.push(this.loadMonthlyStatementFromMD(view.storeArray[j].id));
        // await this.loadMonthlyStatementFromMD(view.storeArray[j].id);
        // await this.loadPrevMonthlyStatementFromMD(view.storeArray[j].id);
        // await this.loadStatisticsDynamicActualShifts(view.storeArray[j].id);
      }

      return Promise.all(promises).finally(() => {
        console.log("finished loading MFS");
      });
    },
    loadMonthlyStatementFromMD: function (storeId) {
      let view = this;
      let promise = new Promise(function (resolve, reject) {
        let params = {
          storeId: storeId,
          date: view.timeframeStart.format("YYYY-MM-DD"),
        };
        // console.log("loadMonthlyStatementFromMD params", params);
        view.$helpers
          .GetCall("/api/sec/proxy/md/monthlyfinancialstatements", params)
          .then((response) => {
            let tmpObjectForSet = view.monthlyStatements[storeId] ? view.monthlyStatements[storeId] : {loading: true, confirmed: false};
            let statement = response.data;
            tmpObjectForSet.loading = false;
            tmpObjectForSet.confirmed = statement.length > 0 ? true : false;
            for (let k = 0; k < statement.length; k++) {
              if (!statement[k].confirmed) {
                tmpObjectForSet.confirmed = false;
              }
            }
            view.$set(view.monthlyStatements, storeId, tmpObjectForSet);

            resolve("");
          })
          .catch((e) => {
            console.log(e);
            reject(e);
          });
      });
      return promise;
    },


  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.sub-header {
  font-size: 32px;
  text-align: left;
  color: #e51550;
  border-bottom: 1px solid #ccc;
  padding: 5px;
  font-weight: 400;
  margin-bottom: 25px;
  width: 100%;
}

.table > thead > tr > th {
  border-top: 0;
}

.xColumn2 {
  width: 48%;
  text-align: left;
  float: left;
  margin-left: 1%;
  margin-right: 1%;
  overflow-y: auto;
  padding-bottom: 20px;
}

.xColumn2 > .header {
  display: inline-block;
  width: 100%;
  color: #e51550;
  font-size: 15px;
  font-weight: 700;
  border-bottom: 1px solid #ccc;
  text-align: left;
  padding: 7px;
}

.xColumn {
  width: 98%;
  text-align: left;
  float: left;
  margin-left: 1%;
  margin-right: 1%;
  overflow-y: auto;
  padding-bottom: 20px;
}

.xColumn > .header {
  display: inline-block;
  width: 100%;
  color: #e51550;
  font-size: 15px;
  font-weight: 700;
  border-bottom: 1px solid #ccc;
  text-align: left;
  padding: 7px;
}

.entryBox {
  font-size: 13px;
  text-align: left;
  padding: 12px 7px;
}

.entryBox .entryHeader {
  display: inline-block;
  width: 50%;
  float: left;
  color: #555;
  font-weight: 700;
}

.entryBox .entryHeaderLight {
  display: inline-block;
  width: 50%;
  float: left;
  color: var(--contrast-5);
  font-weight: 200;
}

.entryBox .entryData {
  display: inline-block;
  width: 50%;
  float: right;
  color: var(--contrast-5);
  font-weight: 200;
}

.entryBox.triple .entryHeader.first {
  display: inline-block;
  width: 50%;
  float: left;
  color: #555;
  font-weight: 700;
}

.entryBox.triple .entryHeader {
  display: inline-block;
  width: 25%;
  float: left;
  color: #555;
  font-weight: 700;
}

.entryBox.triple .entryHeaderLight.first {
  display: inline-block;
  width: 50%;
  float: left;
  color: var(--contrast-5);
  font-weight: 200;
}

.entryBox.triple .entryHeaderLight {
  display: inline-block;
  width: 25%;
  float: left;
  color: var(--contrast-5);
  font-weight: 200;
}

.entryBox.triple .entryData.first {
  display: inline-block;
  width: 50%;
  float: left;
  color: var(--contrast-5);
  font-weight: 200;
}

.entryBox.triple .entryData {
  display: inline-block;
  width: 25%;
  float: left;
  color: var(--contrast-5);
  font-weight: 200;
}

.btn-ml {
  color: #fff;
  background-color: var(--ml);
  border-color: var(--ml);
}

.btn-ml:hover {
  color: #fff;
  background-color: #cc1347;
  border-color: #cc1347;
}

.table th {
  vertical-align: middle;
}

</style>
